<template>

<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9243 10.4243C13.1586 10.1899 13.1586 9.81005 12.9243 9.57574L8.42426 5.07574C8.18995 4.84142 7.81005 4.84142 7.57574 5.07574L3.07574 9.57574C2.84142 9.81005 2.84142 10.1899 3.07574 10.4243C3.31005 10.6586 3.68995 10.6586 3.92426 10.4243L8 6.34853L12.0757 10.4243C12.3101 10.6586 12.6899 10.6586 12.9243 10.4243Z" fill="currentColor"/>

</template>
